import type { ProgressStatus } from './constants'
import type {
  Check as CheckApi,
  CheckContext,
  WorkflowListItem as WorkflowListItemApi,
} from '@app/shared/types/sf-data'

export type parsedDescription = {
  type: 'math' | 'markup'
  content: string
  key: string
}

export type Check = {
  currentUserMentioned?: boolean
} & CheckApi

export type ChecksState = {
  accountId: number | undefined
  reconciliationId: number | undefined
  checks: Check[]
  timestamp: Date | undefined
  loadingStatus: ProgressStatus
  setupStatus: ProgressStatus
  error: boolean
}

export enum ChecksCalculationStatus {
  Calculating = 'CALCULATING',
  ReadyForReload = 'READY_FOR_RELOAD',
  UpToDate = 'UP_TO_DATE',
}

export type ContextByTypeAndId = {
  accounts: Record<number, CheckContext>
  reconciliations: Record<number, CheckContext>
}

export type Workflow = WorkflowListItemApi & {
  expanded: boolean
}

export type MockGeneralWorkflow = {
  id: 'general'
  default: boolean
  name: 'General'
  reconciliationTextIds: number[]
  accountIds: number[]
}

export type TreeHierarchyWorkflow = Omit<
  WorkflowListItemApi,
  'id' | 'accountIds' | 'reconciliationTextIds'
> & {
  id: string
  type: 'workflow'
  children: TreeHierarchyContext[] | TreeHierarchyCheck[]
}

export type TreeHierarchyContext = Omit<
  CheckContext,
  'id' | 'accountIds' | 'reconciliationTextIds'
> & {
  id: string
  children: TreeHierarchyCheck[]
}

export type TreeHierarchyCheck = Check & {
  type: 'check'
  children: undefined
}

export type TreeHierarchyRoot = {
  id: string
  name: string
  type: 'group'
  children: TreeHierarchyItem[]
}

export type TreeHierarchyItem =
  | TreeHierarchyWorkflow
  | TreeHierarchyContext
  | TreeHierarchyCheck
  | TreeHierarchyRoot

export type CheckGroup = 'accounts' | 'reconciliations' | 'general'
